import React from 'react';
import { Receipt } from 'lucide-react';
import CmsManagedInfoPage from '../components/site/CmsManagedInfoPage';

const TermsOfSaleFallback: React.FC = () => (
  <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
    <main className="flex-grow">
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 text-white py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Receipt className="w-16 h-16 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Sale</h1>
            <p className="text-xl text-blue-100">Terms and conditions for purchasing products from our store</p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none text-gray-600">
              <p className="text-sm text-gray-500 mb-8">Last updated: March 31, 2024</p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Order Acceptance</h2>
              <p>
                All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any
                order for any reason, including but not limited to product availability, errors in product information,
                or suspected fraud.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Pricing and Payment</h2>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>All prices are listed in US dollars unless otherwise indicated</li>
                <li>Prices do not include applicable taxes and shipping fees</li>
                <li>We accept major credit cards, PayPal, and other payment methods as indicated at checkout</li>
                <li>Payment must be received before orders are processed</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Shipping and Delivery</h2>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Delivery times are estimates and not guaranteed</li>
                <li>Risk of loss passes to you upon delivery to the carrier</li>
                <li>You are responsible for providing accurate shipping information</li>
                <li>Additional fees may apply for address corrections or re-delivery</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Product Descriptions</h2>
              <p>
                We make every effort to display our products and their colors accurately. However, actual colors may
                vary depending on your monitor and device settings.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Warranty Disclaimer</h2>
              <p>
                Products are sold &quot;as is&quot; without warranties of any kind, either express or implied, except as
                expressly stated in writing.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Limitation of Liability</h2>
              <p>
                Our liability is limited to the purchase price of the product. We are not liable for any indirect,
                incidental, or consequential damages.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Governing Law</h2>
              <p>These terms are governed by the laws of the State of New York, without regard to conflict of law principles.</p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Contact</h2>
              <p>For questions about these terms, please contact us at sales@nlsstore.com.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
);

const TermsOfSale: React.FC = () => (
  <CmsManagedInfoPage route="/terms-of-sale" fallback={<TermsOfSaleFallback />} />
);

export default TermsOfSale;
